import fetchData from "./fetchData";

const defaultWesbsite = {
    disableLoadingAndEnableBtn(btnaction, loadingbtn = "loadingbase") {
        //Disabled Loading
        document.querySelector(`.${loadingbtn}`).classList.remove("d-flex");

        //Enabled Submit Button
        document.querySelector(`.${btnaction}`).removeAttribute("disabled");
    },
    enabledLoadingAndDisableBtn(btnaction, loadingbtn = "loadingbase") {
        //Enable Loading
        document.querySelector(`.${loadingbtn}`).classList.add("d-flex");

        //Disable Submit Button
        document.querySelector(`.${btnaction}`).setAttribute("disabled", true);
    },
    showPassword(inputelement, element) {
        if (inputelement.value !== "") {
            const isShowing = element.getAttribute("data-show") === "true";

            // Toggle data-show attribute
            element.setAttribute("data-show", isShowing ? "false" : "true");

            // Toggle input type
            inputelement.setAttribute("type", isShowing ? "text" : "password");

            // Toggle class based on new data-show value
            if (isShowing) {
                element.classList.add("showing-password");
            } else {
                element.classList.remove("showing-password");
            }
        }

        return;
    },
    createErrorMessageElement(idname, errorMessage, removespan = 5000) {
        //Check when span exist
        if (!document.querySelector("span.errorMessage")) {
            //Get Element to Apeend
            let input = document.getElementById(idname);

            //Add Error Message Class for the input
            input.classList.add("is-invalid");

            //Create Element
            let spanError = document.createElement("span");

            //Set Attribute for the element
            spanError.setAttribute(
                "class",
                "errorMessage order-3 invalid-feedback"
            );
            spanError.innerText = errorMessage;

            //Create Element After Input
            input.after(spanError);

            //Remove Span Element
            setTimeout(() => {
                //Remove ErrorMessage class from the input
                input.classList.remove("is-invalid");

                //Remove Span Error Message
                document.querySelector("span.errorMessage").remove();
            }, removespan);

            return;
        }

        return;
    },
    checkWidth(
        screenWidth,
        limitwidth = 1180,
        classname = "basecontent",
        linkclassname = "linkmodule"
    ) {
        let getMobileConditional = sessionStorage.getItem("mobileconditional");

        //Set Conditional for hide Backoffice Module Content
        if (screenWidth <= limitwidth) {
            //Check old data from sessionStorage
            if (
                getMobileConditional &&
                document.querySelector(".sidebar").classList.contains("d-none")
            ) {
                sessionStorage.removeItem("mobileconditional");
            }

            if (
                document.querySelector(".sidebar").classList.contains("d-none")
            ) {
                //Show Module Content
                document
                    .querySelector(`.${classname}`)
                    .classList.remove("d-none");
            } else {
                //Hide Module Content
                document.querySelector(`.${classname}`).classList.add("d-none");
            }

            //Remove all hrefs from menu
            [...document.querySelectorAll(`.${linkclassname}`)].forEach(
                (value) => value.removeAttribute("href")
            );
        }

        if (screenWidth > limitwidth) {
            //Show Sidebar
            document.querySelector(".sidebar").classList.remove("d-none");

            //Show Module Content
            document.querySelector(`.${classname}`).classList.remove("d-none");

            sessionStorage.removeItem("mobileconditional");
        }
    },
    primarySidebarConditional(
        event,
        sessionstoragename = "mobileconditional",
        id = null
    ) {
        //Check Element
        if (!event.target.parentElement.hasAttribute("data-mobileindicate")) {
            return;
        }

        //List of Nav Menu Items
        const NAVMENUITEMS = {
            booking: `${window.location.origin}/admin/booking`,
            contract: `${window.location.origin}/admin/contract`,
            settings: `${window.location.origin}/admin/settings`,
            logout: `${window.location.origin}/logout`,
            managebooking: `${window.location.origin}/admin/managebooking`,
            admin: `${window.location.origin}/admin`,
            user: `${window.location.origin}/admin/user`,
            admincontract: `${window.location.origin}/admin/admincontract`,
            location: `${window.location.origin}/admin/location`,
            accessories: `${window.location.origin}/admin/accessories`,
            offices: `${window.location.origin}/admin/offices`,
            logout: `${window.location.origin}/logout`,
            adminbooking: `${window.location.origin}/admin/adminbooking`,
            officesshow: `${window.location.origin}/admin/offices/show=${id}`,
            officescreate: `${window.location.origin}/admin/offices/create`,
            accessoriesshow: `${window.location.origin}/admin/accessories/show=${id}`,
            accessoriescreate: `${window.location.origin}/admin/accessories/create`,
            locationcreate: `${window.location.origin}/admin/location/create`,
            locationshow: `${window.location.origin}/admin/location/show=${id}`,
            userscreate: `${window.location.origin}/admin/user/create`,
            usersshow: `${window.location.origin}/admin/user/usershow=${id}`,
            pages: `${id}`,
            adminsettings: `${window.location.origin}/admin/adminsettings`,
            account: `${window.location.origin}/admin/account`,
            test: `${window.location.origin}/admin/test`,
        };

        //Set Session Storage
        sessionStorage.setItem(`${sessionstoragename}`, true);

        //Get Link Reference
        let linkreference = event.target.parentElement.getAttribute(
            "data-mobileindicate"
        );

        //Check Mobile Indicate
        if (!Object.hasOwn(NAVMENUITEMS, linkreference)) {
            return;
        }

        //Check Logout routine
        if (linkreference === "logout") {
            //Remove Session Storage
            sessionStorage.removeItem("mobileconditional");
        }

        //Redirect
        window.location.replace(NAVMENUITEMS[linkreference]);
    },
    primaryContentConditional(screenWidth, limitwidth = 1180) {
        let getMobileConditional = sessionStorage.getItem("mobileconditional");

        //Check width - For Mobile and Tablet
        if (screenWidth <= limitwidth && getMobileConditional) {
            //Hide Sidebar
            document.querySelector(".sidebar").classList.add("d-none");

            //Show Module Content
            document.querySelector(".basecontent").classList.remove("d-none");
        }

        //For Desktop
        if (screenWidth > limitwidth) {
            //Show Sidebar
            document.querySelector(".sidebar").classList.remove("d-none");

            //Show Module Content
            document.querySelector(".basecontent").classList.remove("d-none");
        }

        //Remove Session Storage
        sessionStorage.removeItem("mobileconditional");
    },
    showSidebarMenu() {
        //Set Mobile Conditional
        sessionStorage.setItem("mobileconditional", false);

        //Hide Sidebar
        document.querySelector(".sidebar").classList.remove("d-none");

        //Show Module Content
        document.querySelector(".basecontent").classList.add("d-none");
    },
    checkEmail(
        email,
        checkemailurl,
        csrftolken,
        buttonelement,
        method = "PATCH",
        emailcontaineridname = "email-container"
    ) {
        //Disabled Button
        buttonelement.setAttribute("disabled", true);

        //Active Loading
        document.querySelector(".loadingbase").classList.add("d-flex");

        //Send Data
        let response = fetchData.structureTosendData(
            checkemailurl,
            { email: email.trim() },
            csrftolken,
            method
        );

        //Check Promisse
        response
            .then((value) => {
                //Desactive Loading
                document
                    .querySelector(".loadingbase")
                    .classList.remove("d-flex");

                //Enabled Button
                buttonelement.removeAttribute("disabled");

                //Show Message
                alert(value.message);
            })
            .catch((error) => {
                //Desactive Loading
                document
                    .querySelector(".loadingbase")
                    .classList.remove("d-flex");

                //Enabled Button
                buttonelement.removeAttribute("disabled");

                throw new Error(error);
            });

        return false;
    },
    dynamicStyleModuleName(modulename) {
        //Split the Word
        let moduleNameWords = modulename.includes(" ")
            ? modulename.split(" ")
            : modulename;

        //Check by Array Type
        if (!Array.isArray(moduleNameWords)) {
            //Get the First Letter and Uppercase
            let firstLetter = moduleNameWords.at(0).toUpperCase();

            //Uppercase Word
            moduleNameWords = moduleNameWords.replace(
                moduleNameWords.at(0),
                firstLetter
            );

            return moduleNameWords;
        }

        let newValueForModuleNameWords = moduleNameWords.map((value) => {
            //Get the First Letter and Uppercase
            let firstLetter = value.at(0).toUpperCase();

            //Uppercase Word
            value = value.replace(value.at(0), firstLetter);

            return value;
        });

        return newValueForModuleNameWords.join(" ");
    },
    resumeMessage(text, limit) {
        //console.log(text);
        if (text !== undefined) {
            let resume =
                text.length > limit ? `${text.substring(0, limit)}...` : text;

            return resume;
        }
    },
    turnBack(indexurl, limitwidth = 1180) {
        //Set Session Storage
        if (window.screen.width <= limitwidth) {
            sessionStorage.setItem("mobileconditional", true);
        }

        //window.history.back();
        window.location.replace(indexurl);
    },
};

export default defaultWesbsite;
